import React from 'react'
import { Modal, Button, Result } from "antd";

interface IProps {
  showModal: boolean;
  closeModal(): void;
  certData: any[]
};

export default function CertModal(props: IProps) {
  const { showModal, certData, closeModal } = props;
  const [ downLoading, setLoading ] = React.useState(false);
  // 下载证书
  const downFile = () => {
    setLoading(true);
    const file = certData[0];
    let x=new XMLHttpRequest();
    x.open("GET", file.file_url, true);
    x.responseType = 'blob';
    x.onload = function(){
      let url = window.URL.createObjectURL(x.response)
      let a = document.createElement('a');
      a.href = url;
      a.download = file.file_bucket_name;
      a.click();
      setLoading(false);
    }
    x.send();
  }
  // 查看文件
  const queryFile = () => {
    const file = certData[0].file_url;
    window.open(file);
  }
  return (
    <Modal
      title="证书查看"
      visible={showModal}
      onCancel={closeModal}
      footer={null}
      maskClosable={false}
    >
      {
        certData.length > 0 ? 
        <div style={{display: 'flex', justifyContent: "center", alignItems: "center"}}>
          <Button type="primary" onClick={queryFile} style={{marginRight: 10}}>查看证书</Button>
          <Button type="primary" onClick={downFile} loading={downLoading}>下载证书</Button>
        </div>
        : <Result title="暂无相关证书，请继续加油！" />
      }
    </Modal>
  )
}
